module.exports = __webpack_public_path__ + "static/media/-_Sourcing & Recruitment.48567ac2.png";